var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _line, _line2, _line3, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _path, _path2, _path3, _rect32, _rect33, _rect34, _rect35, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingHeaderImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 433,
    viewBox: "0 0 433 433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 225.934,
    cy: 214,
    r: 172,
    fill: "#2E4063"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 145.25,
    y: 93.1896,
    width: 200.684,
    height: 266.085,
    rx: 7.61654,
    fill: "#DEF2F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104.934,
    y: 69,
    width: 226.665,
    height: 275.941,
    rx: 7.08561,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 117.935,
    y: 94.9999,
    width: 199.482,
    height: 84.5844,
    rx: 10.5119,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 142.381,
    y: 162.96,
    width: 11.4898,
    height: 2.93356,
    rx: 1.46678,
    fill: "#A1AEBD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 161.938,
    y: 162.96,
    width: 11.4898,
    height: 2.93356,
    rx: 1.46678,
    fill: "#A1AEBD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 181.495,
    y: 162.96,
    width: 11.4898,
    height: 2.93356,
    rx: 1.46678,
    fill: "#A1AEBD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 201.052,
    y: 162.96,
    width: 11.4898,
    height: 2.93356,
    rx: 1.46678,
    fill: "#A1AEBD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 220.609,
    y: 162.96,
    width: 11.4898,
    height: 2.93356,
    rx: 1.46678,
    fill: "#A1AEBD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 240.166,
    y: 162.96,
    width: 11.4898,
    height: 2.93356,
    rx: 1.46678,
    fill: "#A1AEBD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 259.724,
    y: 162.96,
    width: 11.4898,
    height: 2.93356,
    rx: 1.46678,
    fill: "#A1AEBD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 279.28,
    y: 162.96,
    width: 11.4898,
    height: 2.93356,
    rx: 1.46678,
    fill: "#A1AEBD"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 132.356,
    y1: 109.79,
    x2: 300.792,
    y2: 109.79,
    stroke: "#D7D8D9",
    strokeWidth: 0.244464
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 132.356,
    y1: 134.97,
    x2: 300.792,
    y2: 134.97,
    stroke: "#D7D8D9",
    strokeWidth: 0.244464
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 132.356,
    y1: 158.438,
    x2: 300.792,
    y2: 158.438,
    stroke: "#D7D8D9",
    strokeWidth: 0.244464
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 145.07,
    y: 116.023,
    width: 7.82284,
    height: 42.5367,
    rx: 3.91142,
    fill: "#A1AEBD"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 145.07,
    y: 135.091,
    width: 7.82284,
    height: 23.4685,
    rx: 3.91142,
    fill: "#2E4063"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 164.627,
    y: 129.469,
    width: 7.82284,
    height: 29.0912,
    rx: 3.91142,
    fill: "#A1AEBD"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 164.627,
    y: 144.137,
    width: 7.82284,
    height: 14.4234,
    rx: 3.91142,
    fill: "#2E4063"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 184.185,
    y: 124.824,
    width: 7.82284,
    height: 33.736,
    rx: 3.91142,
    fill: "#A1AEBD"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 184.185,
    y: 135.092,
    width: 7.82284,
    height: 23.4685,
    rx: 3.91142,
    fill: "#2E4063"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 203.741,
    y: 118.957,
    width: 7.82284,
    height: 39.6031,
    rx: 3.91142,
    fill: "#A1AEBD"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 203.741,
    y: 141.693,
    width: 7.82284,
    height: 16.868,
    rx: 3.91142,
    fill: "#2E4063"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 223.299,
    y: 129.469,
    width: 7.82284,
    height: 29.0912,
    rx: 3.91142,
    fill: "#A1AEBD"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 223.299,
    y: 135.825,
    width: 7.82284,
    height: 22.7351,
    rx: 3.91142,
    fill: "#2E4063"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 242.857,
    y: 135.092,
    width: 7.82284,
    height: 23.4685,
    rx: 3.91142,
    fill: "#A1AEBD"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 242.857,
    y: 141.692,
    width: 7.82284,
    height: 16.868,
    rx: 3.91142,
    fill: "#2E4063"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 280.261,
    y: 112.846,
    width: 7.82284,
    height: 45.7147,
    rx: 3.91142,
    fill: "#A1AEBD"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 280.261,
    y: 124.824,
    width: 7.82284,
    height: 33.736,
    rx: 3.91142,
    fill: "#2E4063"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 262.414,
    y: 121.646,
    width: 7.82284,
    height: 36.914,
    rx: 3.91142,
    fill: "#A1AEBD"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 262.414,
    y: 141.692,
    width: 7.82284,
    height: 16.868,
    rx: 3.91142,
    fill: "#2E4063"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 132.547,
    y: 179.584,
    width: 175.852,
    height: 3.58364,
    rx: 1.79182,
    fill: "#A1AEBD"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 132.547,
    y: 308.1,
    width: 175.852,
    height: 3.58364,
    rx: 1.79182,
    fill: "#A1AEBD"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 132.547,
    y: 188.048,
    width: 158.098,
    height: 3.58364,
    rx: 1.79182,
    fill: "#A1AEBD"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 132.873,
    y: 316.386,
    width: 155.441,
    height: 3.58364,
    rx: 1.79182,
    fill: "#A1AEBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M144.056 265.004C194.746 261.544 246.588 296.163 294.196 290.969L294.196 271.929C266.309 285.777 198.136 245.619 144.056 249.427L144.056 265.004Z",
    fill: "url(#paint0_linear_2196_131059)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M144.056 249.721C194.746 246.256 256.294 269.42 294.196 264.914L294.196 239.323C266.155 251.801 198.136 223.032 144.056 226.845L144.056 249.721Z",
    fill: "url(#paint1_linear_2196_131059)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M144.056 227.099C204.134 224.427 239.51 227.843 294.196 225.052L294.196 208.655C263.695 208.655 200.437 210.749 144.056 208.655L144.056 227.099Z",
    fill: "url(#paint2_linear_2196_131059)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 137.42,
    y: 208.654,
    width: 6.63602,
    height: 56.8432,
    fill: "#2E4063"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 294.194,
    y: 208.654,
    width: 6.63602,
    height: 16.6297,
    fill: "#2E4063"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 294.194,
    y: 239.193,
    width: 6.63602,
    height: 25.7004,
    fill: "#2E4063"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 294.194,
    y: 272.149,
    width: 6.63602,
    height: 18.7462,
    fill: "#2E4063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M369.415 269.108C372.572 270.196 376.025 268.52 376.998 265.326C383.7 243.329 385.82 220.169 383.202 197.28C380.584 174.391 373.289 152.308 361.794 132.392C360.125 129.5 356.383 128.647 353.553 130.42V130.42C350.722 132.192 349.875 135.918 351.537 138.815C362.079 157.198 368.774 177.558 371.186 198.654C373.599 219.75 371.675 241.096 365.555 261.385C364.591 264.582 366.257 268.021 369.415 269.108V269.108Z",
    fill: "#BEE5E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0758 242.887C70.8455 243.735 68.9032 247.044 69.8667 250.242C73.4462 262.123 78.3311 273.57 84.4318 284.375C86.0738 287.283 89.8072 288.171 92.6543 286.426V286.426C95.5015 284.68 96.3835 280.962 94.7496 278.05C89.2585 268.261 84.8406 257.907 81.5727 247.17C80.6004 243.975 77.3061 242.039 74.0758 242.887V242.887Z",
    fill: "#BEE5E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2196_131059",
    x1: 294.176,
    y1: 281.252,
    x2: 143.809,
    y2: 276.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10AC84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2196_131059",
    x1: 294.176,
    y1: 256.054,
    x2: 143.839,
    y2: 250.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10AC84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2196_131059",
    x1: 294.176,
    y1: 222.404,
    x2: 144.432,
    y2: 210.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10AC84"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingHeaderImg);
export default __webpack_public_path__ + "static/media/LandingHeaderImg.eac3fc6f.svg";
export { ForwardRef as ReactComponent };